// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    variant: "h1",
    css: css`
        @media print {
            font-size: 34px !important;
        }
    `,
};
const brandText: TypographyPresentationProps = {
    size: fontConfig.fontSize.small,
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 4px;
        line-height: 19px;
    `,
};
pageTitleStyles.brandStyles = {
    logoImage: {
        css: css`
            margin-bottom: 4px;
            img {
                max-width: 150px;
                max-height: 30px;
            }
        `,
    },
    nameLink: {
        typographyProps: {
            ...brandText,
        },
    },
    nameText: {
        ...brandText,
    },
};
